import wx from 'weixin-js-sdk';
import { isWeChatBrowser, isJudgeDevice, isInApp } from '@/utils/is';
import { Toast } from 'vant';
import dsbridge from 'dsbridge';

/**
 * 跳转原生应用
 * @param {*} params
 * @param jumpType:30	自定义链接	APP内部跳转		自定义H5链接
 * 44	H5触发打开外部浏览器 访问链接 1.目前用于访问微信客服
 * 66	车载流量
 * 65	访问微信小程序页面contentId：拉起的小程序的username	jumpPath：小程序某个页面地址	remark 备注 1.暂时 jumpType跳转微信小程序类型 用于username使用
 */
export function jumpToNative(params) {
  params.zone_home_code = params.zone_home_code ? params.zone_home_code : '';
  let NATIVE_URL = 'bjev-zhgj://com_dj_xny?';
  Object.keys(params).forEach((key, index, arr) => {
    NATIVE_URL = `${NATIVE_URL}${key}=${params[key]}${(arr.length - 1) !== index ? '&' : ''}`;
  });
  window.location.href = NATIVE_URL;
}

export function doShare(params) {
  if (params.imageDataString) {
    params.imageDataString = params.imageDataString.replace(/^data:image\/\w+;base64,/, '');
  }
  if (isWeChatBrowser()) {
    // 微信
    wx.miniProgram.navigateTo({
      // url: `/packageA/pages/c2m/cashier/index?orderInfo=${info}`
    });
    return;
  }
  console.log(JSON.stringify(params));
  if (isJudgeDevice() === 'IOS') {
    window.doShare(JSON.stringify(params));
  }
  if (isJudgeDevice() === 'Android') {
    window.AndroidJs.doShare(JSON.stringify(params));
  }
}

/**
 * 保存本地图片
 * @param {*} base64
 * @isWeChatSave 微信内保存
 * @returns
 */
export function saveToLoacl(base64, isWeChatSave = false) {
  if (isWeChatSave && isWeChatBrowser()) {
    // 微信
    wx.miniProgram.postMessage({
      data: {
        imgData: base64,
      }, // 传入参数
    });
    // wx.miniProgram.navigateBack({
    //   delta: 1,
    // });
  }
  const base64Str = base64.replace(/^data:image\/\w+;base64,/, '');
  if (isJudgeDevice() === 'IOS') {
    window.saveImageDataToAlbum(base64Str);
  }
  if (isJudgeDevice() === 'Android') {
    window.AndroidJs.saveImageDataToAlbum(base64Str);
  }
}

function isYueYeAndroidApp() {
  return [
    'baic-orv-app-android',
  ].some(v => navigator.userAgent.includes(v));
}

export function queryLocal() {
  if (isJudgeDevice() === 'IOS') {
    console.log(window.getCurrentLocation, 'window.getCurrentLocation');
    window.getCurrentLocation();
    console.log('已向IOS-APP发起查询经纬度请求');
  }
  else {
    console.log(isYueYeAndroidApp(), 'isYueYeAndroidApp');
    if (isYueYeAndroidApp()) {
      dsbridge.call('getCurrentLocation');
    }
    else {
      window.AndroidJs.getCurrentLocation();
    }
    console.log('已向安卓-APP发起查询经纬度请求');
  }
}

/**
 * app分享
 * @param {*} params
 * @params isWeChatShare 是否进行微信分享
 * @params imageUrl 图片链接（非base64）用于小程序
 * @params path 小程序路径/pages/consult/consult?carName=（因app拼接参数原因，路径后必须携带参数否则分享后无法正确打开小程序页面）
 * doShare参数详情见https://beijing-app.feishu.cn/sheets/shtcn5I2PlKhHfZZPG60tLDDHoe?sheet=jvPXZm
 */
export function appShare(params) {
  if (params?.isWeChatShare && isWeChatBrowser()) {
    // 微信
    wx.miniProgram.postMessage({
      data: params, // 传入参数
    });
    Toast('请点击右上角分享');
    return;
  }
  const _params = {
    ...params,
    userName: 'gh_48c489323464', // 小程序原始ID，gh开头
    programType: process.env.VUE_APP_ENV === 'prod' ? 0 : 2, // 0正式 1 开发 2体验
  };
  doShare(_params);
}

/**
 * 关闭H5返回App界面
 */
export const navigateBackApp = () => {
  if (isJudgeDevice() === 'IOS') {
    window.back();
  }
  if (isJudgeDevice() === 'Android') {
    window.AndroidJs.back();
  }
};

/**
 * 调起App的填写邀请码弹窗
 */
export const popInviteCodeInputView = () => {
  if (isJudgeDevice() === 'IOS') {
    window.popInviteCodeInputView();
  }
  if (isJudgeDevice() === 'Android') {
    window.AndroidJs.popInviteCodeInputView();
  }
};

/**
 * 调起跳转地图
 * 传参：Json格式 locationJson:{longitude:””,latitude:””}
 */
export const jumpToMapApp = (params) => {
  console.log(JSON.stringify(params));
  if (isJudgeDevice() === 'IOS') {
    window.jumpToMap(JSON.stringify(params));
  }
  if (isJudgeDevice() === 'Android') {
    window.AndroidJs.jumpToMap(JSON.stringify(params));
  }
};

/**
 * 在线客服
 * @jumpType 客服类型
 * @configType 1在线客服 0企业微信客服
 * @jumpPath 客服链接
 * @posterSrc 客服海报图
 * @viewSource 页面名，埋点参数
 */
export const jumpToService = ({ jumpType, configType, jumpPath, posterSrc, viewSource }) => {
  if (viewSource) {
    // 点击客服入口埋点
    if (jumpType === '3015') {
      // 车型亮点页
      window.collectEvent('bqxcx_privateServiceClick', {
        bqxcx_pageName_var: viewSource,
      });
    }
    else {
      window.collectEvent('bq_privateServiceClick', {
        bq_pageName_var: viewSource,
      });
    }
  }
  if (!isInApp()) {
    // 小程序
    wx.miniProgram.navigateTo({
      url: `/packageA/pages/onlineServicePoster/index?posterImg=${posterSrc}&jumpType=${jumpType}`,
    });
    return;
  }
  if (+configType === 1) {
    jumpToNative({ jumpType: 60, jumpPath: jumpPath });
  }
  else {
    jumpToNative({ jumpType: 44, jumpPath: jumpPath });
  }
};
